import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-success",
  "use": "status-success-usage",
  "viewBox": "0 0 76.89 76.89",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 76.89 76.89\" id=\"status-success\"><title>资源 114</title><g id=\"status-success_图层_2\" data-name=\"图层 2\"><g id=\"status-success_图层_1-2\" data-name=\"图层 1\"><path d=\"M38.44,0A38.44,38.44,0,1,0,76.89,38.44,38.44,38.44,0,0,0,38.44,0ZM65.39,24.51,34.15,55.75a2.4,2.4,0,0,1-3.28.11L11.65,39a2.4,2.4,0,0,1,3.17-3.62L32.34,50.76,62,21.11a2.4,2.4,0,0,1,3.4,3.4Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/status-success.svg
// module id = 82HO
// module chunks = 268